import React from 'react';

const Support: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-blue-600 text-center mb-8">
          BuyNothings App Support
        </h1>
        
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 border-b-2 border-blue-600 pb-2">
            Contact Information
          </h2>
          <div className="bg-gray-50 p-6 rounded-lg">
            <p className="mb-2"><strong>Email:</strong> support@buynothings.app</p>
            <p className="mb-2"><strong>Response Time:</strong> We typically respond within 24-48 hours</p>
            <p><strong>App Version:</strong> 1.0.0</p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 border-b-2 border-blue-600 pb-2">
            Frequently Asked Questions
          </h2>
          
          <div className="space-y-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="font-semibold mb-2">What is BuyNothings?</h3>
              <p>BuyNothings is a community-driven app that promotes sustainable living by connecting people who want to give away items they no longer need with those who can use them.</p>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="font-semibold mb-2">How do I report a problem with the app?</h3>
              <p>Please email us at support@buynothings.app with a detailed description of the issue, including your device model and iOS version.</p>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="font-semibold mb-2">How do I delete my account?</h3>
              <p>You can delete your account by going to Settings → Account → Delete Account, or by contacting us at support@buynothings.app.</p>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="font-semibold mb-2">Is my personal information safe?</h3>
              <p>Yes, we take privacy seriously. Please review our Privacy Policy for detailed information about how we handle your data.</p>
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 border-b-2 border-blue-600 pb-2">
            Technical Support
          </h2>
          <p className="mb-4">If you're experiencing technical issues:</p>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>Make sure you have the latest version of the app</li>
            <li>Try restarting the app</li>
            <li>Check your internet connection</li>
            <li>Restart your device</li>
          </ul>
          <p className="mt-4">If problems persist, please contact us with details about your device and the issue you're experiencing.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 border-b-2 border-blue-600 pb-2">
            Feature Requests
          </h2>
          <p>We love hearing from our users! If you have suggestions for new features or improvements, please email us at support@buynothings.app.</p>
        </section>

  
      </div>
    </div>
  );
};

export default Support;
